export default {
  placeDetails: {
    layer: 'Vrstva',
    lat: 'Lat.',
    lon: 'Lon.',
    notAvailable: 'Není k dispozici',
    placeDetails: 'Podrobnosti o místu',
    placeName: 'Název',
    latlngCopied: 'Zeměpisná šířka a délka zkopírována',
    lnglatCopied: 'Zeměpisná délka a šířka zkopírována',
    copyLatlng: 'Kopírovat ve formátu zeměpisná šířka,délka',
    copyLnglat: 'Kopírovat ve formátu zeměpisná délka,šířka',
    satelliteView: 'Satelitní pohled'
  }
}
